import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    OnInit,
    Output
} from '@angular/core';
import { map } from 'rxjs/operators';
import { FilterOption } from 'src/app/library/enums/filters/filter-option.enum';
import { SearchType } from 'src/app/library/enums/filters/search-type.enum';
import { IClientResponse } from 'src/app/library/interfaces/client/client-response';
import { FilterService } from 'src/app/library/services/filter/filter.service';
import { SearchConfigService } from 'src/app/library/services/search/search-config.service';

@Component({
    selector: 'app-new-case-search-clients',
    templateUrl: './new-case-search-clients.component.html',
    styleUrls: ['./new-case-search-clients.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewCaseSearchClientsComponent implements OnInit {
    @Output()
    clientSelected: EventEmitter<any> = new EventEmitter<any>();

    public readonly filterOptionEnum = FilterOption;
    public readonly searchTypeEnum = SearchType;
    public readonly searchEndpoint = this.searchConfigService.clients;
    constructor(
        private filterService: FilterService,
        private searchConfigService: SearchConfigService
    ) {}

    ngOnInit(): void {}

    public onScrollDownThreshold(): void {
        this.filterService.loadNextPageEvent();
    }

    get data$() {
        return this.filterService.data$;
    }

    get filtersActive$() {
        return this.filterService.filterConfig$.pipe(
            map(x => {
                if (x) {
                    return x.filters?.some(i => i.selected);
                }
            })
        );
    }

    get dataLoading$() {
        return this.filterService.dataLoading$;
    }

    get searchActive$() {
        return this.filterService.filterConfig$.pipe(
            map(x => {
                if (x) {
                    return !!x.searchText?.trim();
                }
            })
        );
    }

    public getSelectedClient(event: IClientResponse) {
        this.clientSelected.emit(event);
    }
}
